import { useQuery } from 'react-query';

import { api } from '../api';

interface ITransactionDetails {
  nsuTransacao: string;
  nsuHost: string;
  numSerieLeitor: string;
  numLogico: string;
  cartaoBIN: string;
  cartaoHolder: string;
  codAutTransacao: string;
  codTransacao: string;
  codVenda: string;
  dtHrTransacao: Date;
  vlTransacao: number;
  qtdParcela: number;
  numParcela: number;
  vlParcela: number;
  vlTxAdministracao: number;
  vlTxAntecipacao: number;
  vlLiquido: number;
}

export async function getRelatorioMovimento(
  id: string | undefined
): Promise<ITransactionDetails[]> {
  const { data } = await api.get(`transactions/${id}`);

  return data;
}

export function useRelatorioMovimento(id: string | undefined) {
  return useQuery(
    ['relatorio-movimento', id],
    () => getRelatorioMovimento(id),
    {
      staleTime: Infinity,
      retry: 2
    }
  );
}
